export const ExperimentsKeys = {
    sm_medical_director_changes: 'sm_medical_director_changes',
};
